export enum PostLinkedFeatureType {
  EVENT = 'EVENT',
  TASK = 'TASK',
  SCORECARD = 'SCORECARD',
  PHOTO_ALBUM = 'PHOTO_ALBUM',
  FORM = 'FORM',
}

export interface PostAuthor {
  userId: number;
  firstName: string;
  lastName: string;
  picture: string | null;
}

export interface PostReaction {
  id: number;
  userId: number;
  emoji: string;
}

export interface PostImage {
  id: number;
  url: string;
}

export interface PostLinkedFeatureData {
  title: string;
  subtitle: string | null;
  imageUrl: string | null;
  topScores: Array<{ name: string; score: number }> | null;
}

export interface PostComment {
  commentId: number;
  postId: number;
  author: PostAuthor;
  content: string;
  createdAt: string;
}

export interface Post {
  postId: number;
  content: string | null;
  communityId: number;
  author: PostAuthor;
  isPinned: boolean;
  externalUrl: string | null;
  linkedFeatureType: PostLinkedFeatureType | null;
  linkedFeatureId: number | null;
  linkedPhotoAlbumId: string | null;
  linkedFormId: string | null;
  linkedFeatureData: PostLinkedFeatureData | null;
  images: PostImage[];
  reactions: PostReaction[];
  commentsCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreatePostDto {
  content?: string;
  externalUrl?: string;
  linkedFeatureType?: PostLinkedFeatureType;
  linkedFeatureId?: number;
  linkedPhotoAlbumId?: string;
  linkedFormId?: string;
  imageUrls?: string[];
}

export interface UpdatePostDto {
  content?: string;
  externalUrl?: string;
  imageUrls?: string[];
}

export interface CreateCommentDto {
  content: string;
}
